<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

             <span v-if="form.remark" style="color:#ff4d4f;font-size:20px">审核未通过：{{form.remark}}</span>
        <!-- <a-descriptions :column="2" bordered>

            <dict-render :dict-obj="dictObjs['achievements_subject']" :text="form.subject" v-if="form.subject"></dict-render>
            </a-descriptions> -->
            <!-- <a-descriptions layout="vertical" :column="6" bordered v-for="item in form.enterpriseSealInfos" :key="item">
                <a-descriptions-item label="印章选择">
                <dict-render :dict-obj="dictObjs['TypeSeal']" :text="item.sealType"></dict-render>
                </a-descriptions-item>
                <a-descriptions-item label="上（环）排内容">{{item.topContent}}</a-descriptions-item>
                <a-descriptions-item label="横排/下（环）排内容">{{item.middleBottomContent}}</a-descriptions-item>
                <a-descriptions-item label="材料类型">
                <dict-render :dict-obj="dictObjs['stuffSeal']" :text="item.materialType"></dict-render>
                </a-descriptions-item>
                <a-descriptions-item label="规格">{{item.specifications}}</a-descriptions-item>
                <a-descriptions-item label="备注">{{item.sealRemark}}</a-descriptions-item>
            </a-descriptions> -->
            <a-descriptions style="margin-top:20px;" :column="2" bordered>
            <a-descriptions-item   style="width:25%" label="是否为新办市场主体">
                <span v-if="form.isMarket==0">否</span>
                <span v-if="form.isMarket==1">是</span>
            </a-descriptions-item>
            <a-descriptions-item   style="width:25%" label="是否个转企">
                <span v-if="form.isEnterprise==0">否</span>
                <span v-if="form.isEnterprise==1">是</span>
            </a-descriptions-item>
            <!-- <a-descriptions-item  style="width:25%" label="刻章理由">
                <span v-if="form.reason==0">新刻</span>
                <span v-if="form.reason==1">损坏换刻</span>
                <span v-if="form.reason==2">变更换刻</span>
                <span v-if="form.reason==3">丢失</span>
                <span v-if="form.reason==4">其他</span>
            </a-descriptions-item>
            <a-descriptions-item   style="width:25%" label="领取方式">
                <span v-if="form.collectionMethod==0">自取</span>
                <span v-if="form.collectionMethod==1">邮寄</span>
            </a-descriptions-item>
            <a-descriptions-item :span="2" v-if="form.collectionMethod==1" label="领取地址">{{form.mailingAddress}}</a-descriptions-item>
            <a-descriptions-item label="经办人">{{form.agent}}</a-descriptions-item>

            <a-descriptions-item label="联系电话">{{form.agentPhone}}</a-descriptions-item>

            <a-descriptions-item label="授权期限">{{form.authPeriod? form.authPeriod.split(' ')[0] : ''}}</a-descriptions-item>

            <a-descriptions-item label="身份证号码">{{form.agentIdCard}}</a-descriptions-item> -->
            <a-descriptions-item label="营业执照正/副本复印件(PDF格式)及原件电子版照
            片（PDF格式）">
				<file-upload v-model:value="form.businessLicense" :showBtn="false" :disabled="true" />
            </a-descriptions-item>
            <a-descriptions-item label="法人身份证复印件(正反面复印在一张纸上，PDF格式)
            及正反电子版照片（PDF格式）">
				<file-upload v-model:value="form.legalPersonCard" :showBtn="false" :disabled="true" />
            </a-descriptions-item>
            <a-descriptions-item label="经办人身份证复印件(正反面复印在一张纸上，PDF格
            式)及正反电子版照片（PDF格式）">
				<file-upload v-model:value="form.agentCardFile" :showBtn="false" :disabled="true" />
            </a-descriptions-item>
            <a-descriptions-item label="法人半身照（PDF格式）">
				<file-upload v-model:value="form.legalPersonPhoto" :showBtn="false" :disabled="true" />
            </a-descriptions-item>
            <a-descriptions-item label="经办人半身照（PDF格式）">
				<file-upload v-model:value="form.agentPhoto" :showBtn="false" :disabled="true" />
            </a-descriptions-item>
            <!-- <a-descriptions-item label="印章刻章流转单：经办人自备委托书由法人签字并按手印
            或直接加盖法人章(PDF格式)">
				<file-upload v-model:value="form.circulationOrder" :showBtn="false" :disabled="true" />
            </a-descriptions-item> -->
            <a-descriptions-item label="刻章备案登记表：经办人自备委托书由法人签字并按手印
            或直接加盖法人章(PDF格式)">
				<file-upload v-model:value="form.registrationForm" :showBtn="false" :disabled="true" />
            </a-descriptions-item>
            <!-- <a-descriptions-item label="授权委托书：经办人自备委托书由法人签字并按手印
            或直接加盖法人章(PDF格式)">
				<file-upload v-model:value="form.powerOfAttorney" :showBtn="false" :disabled="true" />
            </a-descriptions-item> -->


        </a-descriptions>
    </a-modal>
</template>

<script>
    import {formMixin, dictMixin} from "@/mixins";
    // import DictRender from "@/components/other/DictRender";

    export default {
        name: "Detail",
        mixins: [formMixin, dictMixin],
        components: {
            // DictRender
        },
        data() {
            return {
                dictNames: "stuffSeal,TypeSeal",
                form: {
                    id: null,
                    needName: null,
                    needBody: null,
                    needType: null,
                    needUserName: null,
                    auditTime: null,
                    abutmentPhone: null,
                    abutmentUserName: null,
                    abutmentStartTime: null,
                    abutmentEndTime: null,
                    serviceStatus: null,
                    isOpen: null,
                },
            }
        },
        methods: {
            onClose() {
                this.visible = false
                this.$emit("onCloseModel")
            },
        }
    }
</script>

<style scoped lang="less">

</style>
